var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.5,
    viewBox: "0 0 24 24",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    height: "1.5rem",
    width: "1.5rem",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 9c-2.4 2.667 -5.4 4 -9 4c-3.6 0 -6.6 -1.333 -9 -4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15l2.5 -3.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 14.976l-2.492 -3.776"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 17l.5 -4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17l-.5 -4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye-close.bc81244fdc8da81a4049cfa8a05c537d.svg";
export { ForwardRef as ReactComponent };